<template>
  <section
    v-if="isStandardV2 && missionList.length >= 1"
    data-test="profile-mission-section"
  >
    <div class="profile-mission-v2__header">
      <div class="profile-mission-v2__heading">
        <h2>{{ title }}</h2>
        <!-- <p>{{ $t("mission_progress_summary") }}</p> -->
      </div>

      <router-link
        to="/mission"
        class="v2__all"
        data-test="profile-mission-see-all"
      >
        {{ $t("see_all") }}
        <font-awesome-icon
          icon="chevron-right"
          class="color-primary"
        ></font-awesome-icon>
      </router-link>
    </div>
    <div class="profile-mission-v2">
      <v-card
        v-if="closestMission"
        class="profile-mission-v2__card"
        elevation="0"
        @click="goMission(closestMission)"
        :data-test="`profile-mission-card-${missionItemKey(
          closestMission,
          closestMissionIndex
        )}`"
      >
        <div class="profile-mission-v2__content">
          <h3 class="profile-mission-v2__title">
            {{ closestMission.name }}
          </h3>

          <div class="profile-mission-v2__status">
            <span class="profile-mission-v2__target" aria-hidden="true"></span>
            <span>{{ $t("mission_complete_to_receive_reward") }}</span>
          </div>

          <div class="profile-mission-v2__progress">
            <strong class="profile-mission-v2__reward">
              {{ missionRewardLabel(closestMission) }}
            </strong>
            <div class="profile-mission-v2__bar" aria-hidden="true">
              <span
                :style="{ width: missionProgressPercent(closestMission) + '%' }"
                :data-test="
                  missionCardDataTest(
                    'progress',
                    closestMission,
                    closestMissionIndex
                  )
                "
              ></span>
            </div>

            <div class="profile-mission-v2__meta">
              <span>{{ textType(closestMission) }}</span>
              <strong>{{ missionProgressLabel(closestMission) }}</strong>
            </div>
          </div>
        </div>

        <div class="profile-mission-v2__media">
          <c-img
            class="profile-mission-v2__image"
            :src="closestMission.image_url"
            :data-test="
              missionCardDataTest('img', closestMission, closestMissionIndex)
            "
          ></c-img>

          <button
            type="button"
            class="profile-mission-v2__action"
            :data-test="
              missionCardDataTest(
                'action-btn',
                closestMission,
                closestMissionIndex
              )
            "
            @click.stop="goMission(closestMission)"
          >
            {{ $t("mission_action") || "ทำภารกิจ" }}
          </button>
        </div>
      </v-card>
    </div>
  </section>

  <div v-else-if="missionList.length >= 1">
    <div class="content-between mb-2" v-if="true">
      <div class="f-lg color-primary f-bold">{{ title }}</div>

      <router-link to="/mission" class="color-primary f-sm">
        <u data-lang="all">{{ $t("all") }}</u>
      </router-link>
    </div>
    <template v-if="false">
      <div data-test="profile-mission-detail-container">
        <OtherLoading
          v-if="isDetailLoading"
          variant="dark"
          data-test="profile-mission-detail-loading"
        />
        <ProfileMissionRewardPanel
          v-else-if="selectedMissionDetail.data"
          :detail="selectedMissionDetail"
          @refresh="refreshSelectedMission"
        />
      </div>
    </template>
    <template v-else-if="missionList.length < 2">
      <v-carousel
        :show-arrows="false"
        height="auto"
        :cycle="missionList.length > 1"
        continuous
        :hide-delimiters="missionList.length <= 2"
      >
        <template v-for="(items, index) of missionList">
          <v-carousel-item v-if="(index + 1) % 2 === 1" :key="index">
            <v-row class="flex-nowrap col-gap-md" no-gutters>
              <template v-for="(n, i) in 2">
                <template v-if="+index + i < missionList.length">
                  <v-col :key="i">
                    <v-card
                      class="p-2 rounded-lg card-mission"
                      elevation="0"
                      border
                      :class="
                        index != 0 && missionList.length > 1 ? 'pr-2' : ''
                      "
                      :key="'mission-' + missionList[+index + i].id"
                      @click="
                        $router.push(
                          '/mission/2/' +
                            missionList[+index + i].user_mission_id
                        )
                      "
                    >
                      <v-row v-if="missionList.length == 1">
                        <v-col cols="3" class="d-flex justify-content-center">
                          <div
                            :class="`progress-circle-lg mission-progress-${
                              +index + i
                            }`"
                            id="circle-progress"
                          >
                            <c-img
                              class="mission-icon-lg"
                              :src="missionList[+index + i].image_url"
                            ></c-img>
                          </div>
                        </v-col>
                        <v-col cols="9" class="flex-column d-flex">
                          <div
                            class="line-clamp-2 f-sm break-all mt-2"
                            :style="'flex:1'"
                          >
                            {{ missionList[+index + i].name }}
                          </div>
                          <div class="content-between f-xs">
                            <div>
                              {{ textType(items) }}
                            </div>
                            <div class="color-primary f-bold">
                              {{
                                missionList[+index + i].user_spender >=
                                missionList[+index + i].user_goal
                                  ? numeralFormat(
                                      missionList[+index + i].user_goal
                                    )
                                  : numeralFormat(
                                      missionList[+index + i].user_spender
                                    )
                              }}<span
                                v-if="
                                  missionList[+index + i]
                                    .is_show_only_have_stamp == 0
                                "
                                >/{{
                                  numeralFormat(
                                    missionList[+index + i].user_goal
                                  )
                                }}</span
                              >
                            </div>
                          </div>
                          <div
                            class="content-between f-xs profile-ft-color mt-auto"
                          >
                            <div>{{ $t("expired") }}</div>
                            <div>
                              {{
                                $moment(
                                  missionList[+index + i].expired_date
                                ).format("DD MMM YYYY")
                              }}
                            </div>
                          </div></v-col
                        >
                      </v-row>
                      <template v-else
                        ><div class="d-inline-flex align-items-center mb-1">
                          <div
                            :class="`progress-circle mission-progress-${
                              +index + i
                            }`"
                            id="circle-progress"
                          >
                            <c-img
                              class="mission-icon"
                              :src="missionList[+index + i].image_url"
                            ></c-img>
                          </div>

                          <div
                            class="line-clamp-2 f-sm break-all"
                            :style="'flex:1'"
                          >
                            {{ missionList[+index + i].name }}
                          </div>
                        </div>
                        <div class="content-between f-xs">
                          <div>
                            {{ textType(items) }}
                          </div>
                          <div class="color-primary f-bold">
                            {{
                              missionList[+index + i].user_spender >=
                              missionList[+index + i].user_goal
                                ? numeralFormat(
                                    missionList[+index + i].user_goal
                                  )
                                : numeralFormat(
                                    missionList[+index + i].user_spender
                                  )
                            }}<span
                              v-if="
                                missionList[+index + i]
                                  .is_show_only_have_stamp == 0
                              "
                              >/{{
                                numeralFormat(missionList[+index + i].user_goal)
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="content-between f-xs profile-ft-color">
                          <div>{{ $t("expired") }}</div>
                          <div>
                            {{
                              $moment(
                                missionList[+index + i].expired_date
                              ).format("DD MMM YYYY")
                            }}
                          </div>
                        </div></template
                      >
                    </v-card>
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-carousel-item>
        </template>
      </v-carousel>
    </template>

    <template v-else>
      <carousel
        :wrapAround="true"
        :transition="500"
        :items-to-show="2"
        :autoplay="3000"
        snapAlign="start"
      >
        <slide v-for="(items, index) of missionList" :key="items" class="pr-2">
          <v-card
            class="p-2 rounded-lg card-mission"
            elevation="0"
            border
            :key="'mission-' + items.id"
            @click="$router.push('/mission/2/' + items.user_mission_id)"
            :data-test="`profile-mission-card-${items.id}`"
          >
            <div class="d-inline-flex align-items-center mb-1">
              <div
                :class="`progress-circle mission-progress-${+index}`"
                id="circle-progress"
              >
                <c-img class="mission-icon" :src="items.image_url"></c-img>
              </div>

              <div class="line-clamp-2 f-sm break-all" :style="'flex:1'">
                {{ items.name }}
              </div>
            </div>
            <div class="content-between f-xs">
              <div>
                {{ textType(items) }}
              </div>
              <div class="color-primary f-bold">
                {{
                  items.user_spender >= items.user_goal
                    ? numeralFormat(items.user_goal)
                    : numeralFormat(items.user_spender)
                }}/{{ numeralFormat(items.user_goal) }}
              </div>
            </div>
            <div class="content-between f-xs profile-ft-color">
              <div>{{ $t("expired") }}</div>
              <div>
                {{ $moment(items.expired_date).format("DD MMM YYYY") }}
              </div>
            </div>
          </v-card>
        </slide>

        <template #addons>
          <!-- <navigation /> -->
          <pagination />
        </template>
      </carousel>
    </template>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import OtherLoading from "@/components/other/OtherLoading";
import ProfileMissionRewardPanel from "@/components/profile/ProfileMissionRewardPanel";
export default {
  name: "MissionComponent",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
    OtherLoading,
    ProfileMissionRewardPanel
  },
  data() {
    return {
      isDetailLoading: false,
      missionList: [],
      selectedMissionDetail: {},
      selectedMissionId: null
    };
  },
  computed: {
    isStandardV2() {
      return this.$isStandardV2 || this.lineLayout === "standard-v2";
    },
    closestMissionIndex() {
      if (!this.closestMission) return -1;
      return this.missionList.indexOf(this.closestMission);
    },
    closestMission() {
      return this.missionList.reduce((closest, mission) => {
        if (!closest) return mission;

        const progress = this.missionProgressRatio(mission);
        const closestProgress = this.missionProgressRatio(closest);

        if (progress !== closestProgress) {
          return progress > closestProgress ? mission : closest;
        }

        return this.missionRemainingValue(mission) <
          this.missionRemainingValue(closest)
          ? mission
          : closest;
      }, null);
    },
    title() {
      return this.$t("mission_title") || "มิชชั่นของคุณ";
    }
  },
  created() {
    this.getMissionList();
  },
  methods: {
    async getMissionList() {
      const result = await this.$axios("/api/v1/user/GetMissionList");
      this.missionList = result.detail;
      this.initProgress();
      if (false) {
        this.selectedMissionId = this.missionList[0].user_mission_id;

        this.getMissionDetail(this.selectedMissionId);
      }
      // this.selectedMissionId = null;
      // this.selectedMissionDetail = {};
      // }
    },
    async getMissionDetail(userMissionId) {
      try {
        this.isDetailLoading = true;
        const result = await this.$axios(
          `/api/v1/Mission/get/${userMissionId}`
        );
        const detail = result.detail;
        detail.reward = detail.reward.sort(
          (a, b) => a.when_reach - b.when_reach
        );
        this.selectedMissionDetail = detail;
      } catch (error) {
        this.$logger({
          response: {
            config: {
              url: `/api/v1/Mission/get/${userMissionId}`,
              method: "GET"
            }
          },
          action: {
            action: "ดึงข้อมูล profile mission",
            id: 3,
            note: error.toString()
          }
        });
      } finally {
        this.isDetailLoading = false;
      }
    },
    refreshSelectedMission() {
      this.getMissionList();
    },
    goMission(items) {
      this.$router.push("/mission/2/" + items.user_mission_id);
    },
    missionItemKey(items, index) {
      return items.id || items.user_mission_id || index;
    },
    missionCardDataTest(element, items, index) {
      return `profile-mission-card-${element}-${this.missionItemKey(
        items,
        index
      )}`;
    },
    missionProgressValue(items) {
      const spender = Number(items.user_spender) || 0;
      const goal = Number(items.user_goal) || 0;

      if (goal <= 0) return 0;
      return Math.min(spender, goal);
    },
    missionProgressPercent(items) {
      return Math.round(this.missionProgressRatio(items) * 100);
    },
    missionProgressRatio(items) {
      const goal = Number(items.user_goal) || 0;

      if (goal <= 0) return 0;
      return Math.min(1, this.missionProgressValue(items) / goal);
    },
    missionRemainingValue(items) {
      const goal = Number(items.user_goal) || 0;
      return Math.max(goal - this.missionProgressValue(items), 0);
    },
    missionProgressLabel(items) {
      const value = this.numeralFormat(this.missionProgressValue(items));

      if (items.is_show_only_have_stamp != 0) return value;

      return `${value} / ${this.numeralFormat(Number(items.user_goal) || 0)}`;
    },
    missionRewardLabel(items) {
      return (
        items.random_reward_name ||
        items.reward_name ||
        items.product_name ||
        this.$t("mission_reward")
      );
    },
    createProgress(index, value) {
      var css = ``,
        head = document.head || document.getElementsByTagName("head")[0],
        style = document.createElement("style");
      css = `
      @property --progress-value-${index} {
        syntax: "<integer>";
        initial-value: 0;
        inherits: false;
      }
      @keyframes js-progress-${index} {
        to {
          --progress-value-${index}: ${value};
        }
      }
      .mission-progress-${index} {
        background: radial-gradient(closest-side, white 79%, transparent 80% 100%, white 0), conic-gradient(var(--secondary-color) calc(var(--progress-value-${index}) * 1%), var(--secondary-color-light) 0);
        animation: js-progress-${index} 1s 1 forwards;
      }
      `;
      head.appendChild(style);

      style.type = "text/css";
      if (style.styleSheet) {
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    },
    initProgress() {
      var i = 0;
      for (const items of this.missionList) {
        // if ((i + 1) % 2 === 1) {
        //   for (let n = 0; n < 2; n++) {
        //     if (+i + n < this.missionList.length) {
        let value = Math.round(
          (this.missionList[i].user_spender * 100) /
            this.missionList[i].user_goal
        );

        this.createProgress(i, value);
        // }
        // }
        i++;
      }
    },
    formatNumber(num, precision = 0) {
      const map = [
        { suffix: "M", threshold: 1e6, multiple: 1 },
        { suffix: "K", threshold: 1e4, multiple: 10 },
        { suffix: "K", threshold: 1e3, multiple: 1 },
        { suffix: "", threshold: 1, multiple: 1 }
      ];

      const found = map.find(x => Math.abs(num) >= x.threshold);

      if (found) {
        const formatted =
          (num / found.threshold) * found.multiple + found.suffix;

        return formatted;
      }

      return num;
    },
    textType(items) {
      if (items.mission_redeem_type == 1) return this.$t("total_spend_unit");
      else if (items.mission_redeem_type == 2) {
        if (items.mission_redeem_condition == 1)
          return this.$t("count_purchase_times");
        else return this.$t("count_purchase_unit");
      } else if (items.mission_redeem_type == 3)
        return this.$t("collect_point");
    }
  }
};
</script>

<style scoped lang="scss">
/* @import "@/assets/stylesheets/customVueSlick.css"; */
.profile-mission-v2 {
  overflow: hidden;
  margin: 16px -16px 0;
  // padding: 0 0 16px 0;
  background: radial-gradient(
      circle at 108% 88%,
      rgba(255, 255, 255, 0.9) 0 28%,
      transparent 29%
    ),
    radial-gradient(
      circle at 98% 95%,
      rgba(218, 24, 52, 0.08) 0 42%,
      transparent 43%
    ),
    #f8edf0;
}

.profile-mission-v2__header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  // padding-right: 20px;
}

.profile-mission-v2__heading {
  min-width: 0;
}

.profile-mission-v2__heading h2 {
  overflow: hidden;
  margin: 0;
  color: #222;
  font-size: var(--text-2xl);
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-mission-v2__heading p {
  margin: 0;
  color: #333;
  font-size: var(--text-md);
  font-weight: 500;
  line-height: 1.2;
}

.profile-mission-v2__card {
  display: grid;
  width: 100%;

  min-height: 184px;
  grid-template-columns: minmax(0, 1fr) 31%;
  overflow: hidden;
  border-radius: 16px !important;
  background: #faeeee;
  box-shadow: 0 8px 18px rgba(61, 42, 46, 0.13);
  cursor: pointer;
  text-align: left;
}

.profile-mission-v2__content {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 26px;
}

.profile-mission-v2__title {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: var(--primary-color);
  font-size: var(--text-xl);
  font-weight: 900;
  line-height: 1.3;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
}

.profile-mission-v2__status {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
  color: #333;
  font-size: var(--text-md);
  line-height: 1.3;
}

.profile-mission-v2__target {
  position: relative;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
}

.profile-mission-v2__target::before,
.profile-mission-v2__target::after {
  position: absolute;
  content: "";
}

.profile-mission-v2__target::before {
  top: 4px;
  left: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary-color);
}

.profile-mission-v2__target::after {
  top: -5px;
  right: -4px;
  width: 8px;
  height: 7px;
  border-top: 2px solid var(--primary-color);
  border-right: 2px solid var(--primary-color);
}

.profile-mission-v2__reward {
  display: -webkit-box;
  overflow: hidden;
  margin-bottom: 0.25rem;
  color: #222;
  font-size: var(--text-lg);
  font-weight: 900;
  line-height: 1.3;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.profile-mission-v2__progress {
  margin-top: auto;
}

.profile-mission-v2__bar {
  overflow: hidden;
  height: 6px;
  border-radius: 999px;
  background: #c8c8c8;
}

.profile-mission-v2__bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--primary-color);
}

.profile-mission-v2__meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 6px;
  color: #555;
  font-size: var(--text-md);
  line-height: 1.25;
}

.profile-mission-v2__meta span {
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-mission-v2__meta strong {
  flex: 0 0 auto;
  color: var(--primary-color);
  font-weight: 800;
}

.profile-mission-v2__media {
  display: flex;
  min-width: 0;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.48);
  border-radius: 0 0 0 20px;
}

.profile-mission-v2__image {
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
}

.profile-mission-v2__image :deep(.v-img) {
  height: 100%;
}

.profile-mission-v2__action {
  min-height: 26px;
  margin: 8px 10px 12px;
  border: 0;
  border-radius: 999px;
  background: var(--primary-color);
  color: #fff;
  font-size: var(--text-lg);
  font-weight: 800;
  cursor: pointer;
}

.profile-mission-v2 :deep(.carousel__viewport) {
  overflow: visible;
}

.profile-mission-v2 :deep(.carousel__pagination) {
  gap: 4px;
  margin: 14px 0 0;
  padding: 0 20px 0 0;
}

.profile-mission-v2 :deep(.carousel__pagination-button) {
  width: 32px;
  height: 5px;
  padding: 0;
  border-radius: 999px;
  background: rgba(185, 185, 185, 0.45);
}

.profile-mission-v2 :deep(.carousel__pagination-button::after) {
  display: none;
}

.profile-mission-v2 :deep(.carousel__pagination-button--active) {
  background: var(--primary-color);
}

::v-deep .slick-dots li {
  width: 10px;
  height: 10px;
  margin: 0;
}
::v-deep .slick-dots {
  bottom: -15px;
}
::v-deep .slick-dots li button:before {
  font-family: "slick";
  font-size: var(--text-xs);
  line-height: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  content: "•";
}
::v-deep .slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 10px;
  height: 10px;
  padding: 0;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: transparent;
}
::v-deep .slick-next {
  right: -7px;
}
::v-deep .slick-prev {
  left: -12px;
}
::v-deep .slick-prev,
::v-deep .slick-next {
  width: unset;
  height: unset;
}
::v-deep .slick-next:before {
  content: "\203A";
}
::v-deep .slick-prev:before {
  content: "\2039";
}
::v-deep .slick-prev:before,
::v-deep .slick-next:before {
  font-family: unset;
  color: black;
}
::v-deep .slick-prev.slick-disabled:before,
::v-deep .slick-next.slick-disabled:before {
  display: none;
}

.mission-icon {
  /* background: red; */
  border-radius: 50%;
  /* padding: 1rem; */
  width: 35px;
  height: 35px;
  /* overflow: hidden; */
  /* object-fit: contain; */
  margin-right: 5px;
}

.break-all {
  word-break: break-all;
}
.card-mission {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
#circle-progress {
  .mission-icon {
    position: absolute;
    top: 3px;
    left: 3px;
    overflow: hidden;
  }
  .mission-icon-lg {
    position: absolute;
    top: 5px;
    left: 5px;
    overflow: hidden;
    /* background: red; */
    border-radius: 50%;
    /* padding: 1rem; */
    width: 50px;
    height: 50px;
    /* overflow: hidden; */
    /* object-fit: contain; */
    // margin-right: 5px;
  }
}
.progress-circle {
  position: relative;
  width: 41px;
  height: 41px;
  justify-content: center;
  border-radius: 50%;
  margin-right: 5px;
}
.progress-circle-lg {
  position: relative;
  width: 60px;
  height: 60px;
  justify-content: center;
  border-radius: 50%;
  // margin-right: 5px;
}
</style>
